// extracted by mini-css-extract-plugin
export default {"facetMenu":"uB-z","fixed":"vB-z","nonLayerdFacets":"wB-z","productCount":"xB-z","facetBack":"yB-z","arrow":"zB-z","facetClose":"AB-z"};